import PropTypes from "prop-types"
import { SIGNUP_URL } from "constants/urls"
import Button from "components/ui/Button"

function SignUpButton({ children, size, dark, trackClick }) {
  return (
    <Button
      color="green"
      size={size}
      href={SIGNUP_URL}
      trackClick={trackClick}
      dark={dark}
      shadow={!dark}
      nowrap
    >
      {children}
    </Button>
  )
}

SignUpButton.propTypes = {
  /** Button size */
  size: PropTypes.oneOf(["small", "medium", "flexible"]),
  /** If true, adapt styles for dark background */
  dark: PropTypes.bool,
  /** Track click event - if set, will track click */
  trackClick: PropTypes.string,
  /** Children */
  children: PropTypes.node,
}

export default SignUpButton
